<template>
    <div class="article">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
            <div class="list">
                <articleItem  v-for="(item, index) in articleArr" :key="index" :articleDetail="item" />
            </div>
        </van-list>

    </div>
</template>

<script>
import navbar from '@/components/navbar/index';
import articleItem from '@/components/article/index';
import { listByModule } from '@/api/index';
export default {
    name: 'articlelist',
    components: {
        articleItem,
        navbar
    },
    data() {
        return {
            query: {
                moduleId: '',
                pageSize: 10,
                pageNo: 1,
                schoolId: ''
            },
            title: '',
            loading: false,
            finished: false,
            articleArr: [
            ] //文章列表
        }
    },
    created() {
        console.log(this.$route,111)
        this.query.schoolId = localStorage.getItem('school_id')
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        console.log(isiOS);
        if(this.$route.query.id) {
            console.log(this.$route.query)
            this.query.moduleId = this.$route.query.id;
            this.title = this.$route.query.title;
            // if(isiOS) {
                this.onLoad();
            // }
    
        }
    },
    methods: {
        onLoad() {
            listByModule(this.query)
                .then(res => {
                    if(res.status === 200) {
                        this.articleArr = this.articleArr.concat(res.content.result);
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if(this.articleArr.length >= res.content.pageMap.totalNum) {
                            this.finished = true;
                        }
                        else {
                            this.query.pageNo ++;
                        }
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.article {
    .leftarrow {
        width: .24rem;
        height: .4rem;
    }
    .blackdot {
        width: .46rem;
        height: .1rem;
    }
    .list {
        padding: 0 .4rem;
    }
}
</style>